<template>
<div class="form-builder-field">
	<div class="field-controls">
		<i class="handle-field icon-button fa fa-fw fa-sort"></i>

		<i class="fa fa-trash icon-button" style="margin-left: auto;" v-on:click="$emit('trash')"></i>
	</div>

	<field label="Label" 
		col-class="col-md-4"
		v-model="label"
		v-on:change="emitInput">
	</field>

	<field label="Type" 
		col-class="col-md-4"
		:params="{type:'select',options:typeOptions}"
		v-model="type"
		v-on:change="typeChange">
		<div v-if="typeOptions.find(opt => opt.value == type)" class="text-muted">{{typeOptions.find(opt => opt.value == type).help}}</div>
		<span v-if="type == 'library-file'" class="text-danger">Only employees of {{$store.company.company_name}} will be able to edit this field</span>
	</field>

	<field v-if="fieldsToOmitRequiredFieldsToggle.indexOf(type) == -1"
		label="Required Field" 
		col-class="col-md-4"
		:params="{type:'boolean'}"
		v-model="requiredField"
		v-on:change="emitInput">
	</field>

	<template v-if="type == 'select' || type == 'select-multi'">

		<div class="offset-md-4">

			<label class="m-2">
				<input type="checkbox" v-model="defineOther" v-on:change="emitInput">
				Allow 'Other' value to be defined manually
			</label>

		</div>

		<field
			label="Options" 
			:params="{type:'textarea',placeholder:'Add options separated by a comma'}"
			col-class="col-md-4"
			v-model="optionsText"
			v-on:change="emitInput">
			<div class="text-muted">Example: Red,Blue,Yellow</div>
		</field>

	</template>
	<template v-else-if="type == 'image'">
		<field
			label="Image is static (not editable when form is being filled)" 
			col-class="col-md-4"
			:params="{type:'boolean'}"
			v-model="imageIsStatic"
			v-on:change="emitInput">
			<div class="text-muted">Image will only be selectable when creating a child template, and then it will display on the form as a view-only full-width image.</div>
		</field>
	</template>
	<template v-else-if="type == 'boolean'">
		<field
			label="Language"
			col-class="col-md-4"
			:params="{type:'select',options:buttonLanguageOptions}"
			v-model="buttonLanguage"
			v-on:change="emitInput">
		</field>

		<div class="offset-md-4">
			<div class="ml-2"><label>In order to advance, response must be:</label></div>
			<label class="m-2">
				<input type="checkbox" v-model="positiveResponseRequired" v-on:change="responseRequiredChange(true)">
				Positive (yes)
			</label>
			<label class="m-2">
				<input type="checkbox" v-model="negativeResponseRequired" v-on:change="responseRequiredChange(false)">
				Negative (no)
			</label>
		</div>

		<template v-if="!positiveResponseRequired && !negativeResponseRequired">
			<div class="offset-md-4">
				<field label="Warning Message: Positive Answer"
					class="ml-2"
					col-class="stacked"
					v-model="positiveWarningMessage"
					:params="{type:'textarea',size:'sm'}"
					v-on:change="emitInput">
					<span class="text-muted">If a positive (yes) answer is given, user can proceed, but is shown this message after completion of the form</span>
				</field>
			</div>

			<div class="offset-md-4">
				<field label="Warning Message: Negative Answer"
					class="ml-2"
					col-class="stacked"
					v-model="negativeWarningMessage"
					:params="{type:'textarea',size:'sm'}"
					v-on:change="emitInput">
					<span class="text-muted">If a negative (no) answer is given, user can proceed, but is shown this message after completion of the form</span>
				</field>
			</div>
		</template>

	</template>

	<template v-else-if="type == 'table'">
		<field
			label="Columns"
			:params="{type:'textarea', placeholder:'Add column names separated by a comma'}"
			col-class="col-md-4"
			v-model="columnsText"
			v-on:change="emitInput">
			<div class="text-muted">Example: Red,Blue,Yellow</div>
		</field>

		<field
			label="Rows"
			:params="{type:'textarea', placeholder:'Add row names separated by a comma'}"
			col-class="col-md-4"
			v-model="rowsText"
			v-on:change="emitInput">
			<div class="text-muted">Example: Red,Blue,Yellow</div>
		</field>
	</template>


	<field v-if="fieldTypesWithNoDefaultValue.indexOf(type) == -1"
		 label="Default Value"
		 col-class="col-md-4"
		 v-model="defaultValue"
		 v-on:change="emitInput">
	</field>

	<field v-if="type == 'static-paragraph'"
		v-model="defaultValue"
		:params="{type:'richtext'}"
		v-on:input="emitInput">
	</field>

	<div v-if="type == 'youtube-video'">

		<field
			label="Video URL"
			col-class="col-md-4"
			v-model="defaultValue"
			v-on:change="emitInput">
		</field>

		<div class="mt-3">
			<label class="col-form-label">Video Preview</label>
		</div>

		<youtube-video v-if="defaultValue" :url="defaultValue"></youtube-video>
	</div>

	<template v-if="typeHasConditionalControls">

		<field
			label="Notifications"
			col-class="col-md-4"
			:params="{type:'boolean'}"
			v-model="notificationsActive"
			v-on:change="emitInput">
			<div class="text-muted">Send a notification to a role depending on the answer value. A notification will only be sent if the answer is an EXACT MATCH to the value provided.</div>
		
			<template v-if="notificationsActive">
				<field label="If response is equal to (any match)"
					col-class="stacked"
					v-model="notificationValue"
					:params="conditionalValueParams"
					v-on:change="emitInput">
				</field>

				<div class="d-flex align-items-center my-2">
					<strong class="mr-3">Then send a notification to</strong>

					<button type="button" class="btn btn-light btn-sm" v-on:click="notificationRecipientModal.isVisible = true">
						<i class="fa fa-pen"></i>
						Edit
					</button>
				</div>


				<ul v-if="roleNotificationRecipients.length || externalNotificationRecipients.length || userNotificationRecipients.length" class="list-group" v-on:mouseleave="setRecipientListHover(null, null)">

					<!------ Roles ------>
					<li v-for="(role,index) in roleNotificationRecipients"
						v-if="roleNotificationRecipientOptions.find(o => o.value == role)"
						 class="list-group-item"
						 v-on:mouseover="setRecipientListHover('role', index)">

						<div class="d-flex justify-content-between align-items-center">

							<span>
								<i class="fa fa-users mr-2" title="Job Personnel Role" />
								{{roleNotificationRecipientOptions.find(o => o.value == role).text}}
							</span>

							<span v-if="recipientListHover.type == 'role' && recipientListHover.index == index" class="btn-delete px-1" v-on:click="removeNotificationRecipient('role',index)">
								<i class="fa fa-trash text-danger"></i>
							</span>

						</div>

					</li>

					<!------ Users ------>
					<li v-for="(userId,index) in userNotificationRecipients"
						v-if="userNotificationRecipientOptions.find(o => o.value == userId)"
						 class="list-group-item"
						 v-on:mouseover="setRecipientListHover('user', index)">

						<div class="d-flex justify-content-between align-items-center">

							<span>
								<i class="fa fa-user mr-2" title="Employee" />
								{{userNotificationRecipientOptions.find(o => o.value == userId).text}}
							</span>

							<span v-if="recipientListHover.type == 'user' && recipientListHover.index == index" class="btn-delete px-1" v-on:click="removeNotificationRecipient('user',index)">
								<i class="fa fa-trash text-danger"></i>
							</span>

						</div>
					</li>

					<!------ Externals ------>
					<li v-for="(external,index) in externalNotificationRecipients"
						 class="list-group-item"
						 v-on:mouseover="setRecipientListHover('external', index)">

						<div class="d-flex justify-content-between align-items-center">

							<span>

								<i class="fa fa-street-view mr-2" title="External User" />
								{{external.name}}
								&nbsp;&nbsp;

								<template v-if="'phone' in external && external.phone">
									({{external.phone}})
								</template>

								<template v-else-if="'email' in external && external.email">
									({{external.email}})
								</template>

							</span>

							<span v-if="recipientListHover.type == 'external' && recipientListHover.index == index" class="btn-delete px-1" v-on:click="removeNotificationRecipient('external',index)">
								<i class="fa fa-trash text-danger"></i>
							</span>

						</div>
					</li>

				</ul>

				<ul v-else class="list-group">
					<li class="list-group-item">No recipients to display</li>
				</ul>

				<!---
				<field label="Then send a notification to"
					col-class="stacked"
					:params="{type:'select-multi',options:notificationRecipientOptions}"
					v-on:change="emitInput"
					v-model="notificationRecipients">
				</field>
				--->
			</template>

		</field>

		<field
			label="Conditional Remarks"
			col-class="col-md-4"
			:params="{type:'boolean'}"
			v-model="conditionalRemarksActive"
			v-on:change="emitInput">
			<div class="text-muted">Show additional remarks field depending on answer value</div>

			<template v-if="conditionalRemarksActive">
				<field label="Show conditional remarks field if response is equal to"
					col-class="stacked"
					v-model="conditionalRemarksValue"
					:params="conditionalValueParams"
					v-on:change="emitInput">
				</field>

				<field label="Conditional Remarks Label"
					col-class="stacked"
					v-model="conditionalRemarksLabel"
					v-on:change="emitInput">
				</field>
			</template>

		</field>

		<field
			label="Conditional Image"
			col-class="col-md-4"
			:params="{type:'boolean'}"
			v-model="conditionalImageActive"
			v-on:change="emitInput">
			<div class="text-muted">Ability to add an image depending on answer value</div>
		
			<template v-if="conditionalImageActive">
				<field label="Show conditional image field if response is equal to"
					col-class="stacked"
					v-model="conditionalImageValue"
					:params="conditionalValueParams"
					v-on:change="emitInput">
				</field>

				<field label="Conditional Image Label"
					col-class="stacked"
					v-model="conditionalImageLabel"
					v-on:change="emitInput">
				</field>
			</template>

		</field>

	</template>


	<!------------- Notification Recipient Modal ------------->

	<modal-dialog
		:modal-visible="notificationRecipientModal.isVisible"
		title="Add/Remove Notification Recipients"
		confirm-button-text="Done"
		v-on:confirm="notificationRecipientModal.isVisible = false"
		v-on:closeModal="notificationRecipientModal.isVisible = false">

		<field
			:params="{
				type:'btn-group',
				buttons: [
					{text:'Roles',value:'roles'},
					{text:'Employees',value:'employees'},
					{text:'External Users',value:'external-users'}
				],
				disableNull: true
			}"
			v-model="notificationRecipientModal.currentTab">
		</field>

		<div class="py-4">

			<template v-if="notificationRecipientModal.currentTab == 'roles'">

				<field
					label="Job Personnel Roles"
					col-class="stacked"
					:params="{
						type:'select-multi',
						options: roleNotificationRecipientOptions,
					}"
					v-on:change="emitInput"
					v-model="roleNotificationRecipients">
				</field>

				<span class="text-muted">
					Every employee with one or more of the selected roles will receive a push notification.
				</span>

			</template>

			<template v-else-if="notificationRecipientModal.currentTab == 'employees'">

				<field
					label="Employees"
					col-class="stacked"
					:params="{
						type:'select-multi',
						options: userNotificationRecipientOptions
					}"
					v-on:change="emitInput"
					v-model="userNotificationRecipients">
				</field>

				<span class="text-muted">
					Every selected employee will recieve a push notification.
				</span>

			</template>

			<template v-else-if="notificationRecipientModal.currentTab == 'external-users'">

				<field
					label="Notify by"
					col-class="col-3"
					:params="{
						type: 'boolean',
						doubleLabels: ['Email', 'SMS']
					}"
					v-model="notificationRecipientModal.notifyByPhone">
				</field>

				<field
					label="Name"
					col-class="col-3"
					v-model="notificationRecipientModal.name">
				</field>

				<field
					:label="notificationRecipientModal.notifyByPhone ? 'Mobile #' : 'Email'"
					col-class="col-3"
					v-model="notificationRecipientModal.phoneEmail">
				</field>

				<button 
					type="button" 
					class="btn btn-primary mt-3" 
					:disabled="!notificationRecipientModal.name || !notificationRecipientModal.phoneEmail.length"
					v-on:click="addExternalNotificationRecipient">
					
					<i class="fa fa-plus"></i>
					Add External User
				</button>


			</template>

		</div>

	</modal-dialog>

</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import ModalDialog from "@/components/ModalDialog";
import YoutubeVideo from "@/components/YoutubeVideo"


export default {
	components: {
		ModalDialog,
		Field,
		YoutubeVideo
	},
	props: ["value","jobPersonnelRoles","employees"],
	data() {
		return {
			label: "",
			type: "",
			requiredField: false,
			defaultValue: "",
			optionsText: "",
			columnsText: "",
			rowsText: "",
			defineOther: false,
			imageIsStatic: false,
			positiveResponseRequired: false,
			negativeResponseRequired: false,
			positiveWarningMessage: "",
			negativeWarningMessage: "",
			buttonLanguage: "en",
			buttonLanguageOptions: [
				{text: "English", value: "en"},
				{text: "French", value: "fr"}
			],
			notificationsActive: false,
			notificationValue: "",

			userNotificationRecipients: [],
			roleNotificationRecipients: [],
			externalNotificationRecipients: [],

			// Use to show "delete" icons on notification recipient list
			recipientListHover: {
				type: null,  // 'role', 'user', 'external'
				index: null
			},

			notificationRecipientModal: {

				// General fields
				isVisible: false,
				currentTab: 'roles',

				// External user fields
				name: "",
				notifyByPhone: false,
				phoneEmail: "",
			},

			conditionalRemarksActive: false,
			conditionalRemarksValue: "",
			conditionalRemarksLabel: "",
			conditionalImageActive: false,
			conditionalImageValue: "",
			conditionalImageLabel: "",
			fieldsToOmitRequiredFieldsToggle: ["static-paragraph","weather","youtube-video","library-file"],
			fieldTypesWithNoDefaultValue: ['weather','medical-facility-location','personnel-phone-list','boolean','static-paragraph','image','whiteboard','table','select-multi','youtube-video','library-file'],
			typeOptions: [
				{text: "Text",                value:'text',                 help:"A plain text field"},
				{text: "Textarea",            value:'textarea',             help:"A plain text area field"},
				{text: "Date",                value:'date',                 help:"A date picker"},
				{text: "Time",                value:'time',                 help:"A time picker"},
				{text: "Yes/No (boolean)",    value:'boolean',              help:"A Yes/No button group"},
				{text: "Select",              value:'select',               help:"A drop down with configurable options"},
				{text: "Multiple Select",     value:'select-multi',         help:"A drop down with configurable options and multiple choices"},
				{text: "Static Paragraph",    value:'static-paragraph',     help:"A static paragraph of text"},
				{text: "Image",               value:'image',                help:"An image upload"},
				{text: "Whiteboard",          value:'whiteboard',           help:"A blank, editable canvas"},
				{text: "Weather Widget",      value:'weather',              help:"A weather widget, showing weather either at location of the project, or the location of the user"},
				//{text: "Medical Facility Location",value:'medical-facility-location',help:"A map widget showing directions to the nearest medical facility."},
				{text: "Task List",           value:'tasklist',             help:"A list of tasks that can be built out to show hazards and controls"},
				{text: "Personnel Phone List",value:'personnel-phone-list', help:"A list of selectable phone numbers of employees assigned to the project or service"},
				{text: "Table",               value:'table',                help:"An expandable table of values"},
				{text: "File",        		  value:'library-file',         help:"A selector for files in your company's library"},
				{text: "YouTube Video",       value:'youtube-video',        help:"Plays the video at the provided URL"},
			]
		}
	},
	watch: {
		value() {
			this.setData()
		},
		jobPersonnelRoles() {
			this.setData()
		}
	},
	computed: {
		userNotificationRecipientOptions() {
			return this.userOptions(false)
		},
		roleNotificationRecipientOptions() {
			return [
				{text:'Managing User',value:'managing-user'},
				{text:'Safety Officer',value:'safety-officer'},
				{text:'Equipment Manager',value:'equipment-manager'},
				...this.optionify(this.jobPersonnelRoles,'title')
			]
		},
		typeHasConditionalControls() {
			let validTypes = ["text","select","select-multi","boolean","date","time"]

			if (validTypes.indexOf(this.type) >= 0)
				return true
			else
				return false
		},
		conditionalValueParams() {
			let obj = {
				type: this.type
			}

			if (this.type == 'select' || this.type == 'select-multi') {
				obj.options = this.optionsArray
				obj.type = 'select-multi'
			}
			else if (this.type == 'boolean') {
				obj.type = 'select-multi'
				obj.options = [{text:"Yes (positive)",value:true},{text:"No (negative)",value:false}]
			}

			return obj
		},
		optionsArray() {
			return this.optionsText.split(",").map(item => item.trim())
		},
		columnsArray() {
			let arr = this.columnsText.split(",").map(item => item.trim())
			return (arr.length == 1 && arr[0] == '') ? [] : arr
		},
		rowsArray() {
			let arr = this.rowsText.split(",").map(item => item.trim()).filter(item => item)
			return (arr.length == 1 && arr[0] == '') ? [] : arr
		}
	},
	methods: {
		setData() {
			let vm = this

			let keys = [
				"label",
				"type",
				"requiredField",
				"defineOther",
				"imageIsStatic",
				"positiveResponseRequired",
				"negativeResponseRequired",
				"positiveWarningMessage",
				"negativeWarningMessage",
				"buttonLanguage",
				"notificationsActive",
				"userNotificationRecipients",
				"roleNotificationRecipients",
				"externalNotificationRecipients",
				"notificationValue",
				"conditionalRemarksActive",
				"conditionalRemarksValue",
				"conditionalRemarksLabel",
				"conditionalImageActive",
				"conditionalImageValue",
				"conditionalImageLabel"
			]

			keys.forEach(key => {
				if (key in vm.value)
					this[key] = vm.value[key]
			})

			this.buttonLanguage = vm.value.buttonLanguage === "fr" ? "fr" : "en"

			// legacy: if notificationRecipients is used instead of roleNotificationRecipients, overwrite
			if ('notificationRecipients' in this.value && !('roleNotificationRecipients' in this.value))
				this.roleNotificationRecipients = this.value.notificationRecipients

			if ("options" in this.value && this.value.options) 
				this.optionsText = this.value.options.join(",\n")

			if ("columns" in this.value && this.value.columns)
				this.columnsText = this.value.columns.join(",\n")

			if ("rows" in this.value && this.value.rows)
				this.rowsText = this.value.rows.join(",\n")

			//nonstandard key due to 'default' being  protected keyword
			if ("default" in this.value)
				this.defaultValue = this.value.default

		},
		responseRequiredChange(positive) {
			let vm = this

			this.$nextTick(() => {
				if (positive && vm.positiveResponseRequired)
					vm.negativeResponseRequired = false
				else if (!positive && vm.negativeResponseRequired)
					vm.positiveResponseRequired = false

				vm.emitInput()		
			})
		},
		setRecipientListHover(type, index) {
			this.recipientListHover.type = type
			this.recipientListHover.index = index
		},
		typeChange(value) {
			if (value == 'image') {
				this.defaultValue = ""
			}
			this.emitInput()
		},
		removeNotificationRecipient(type, index) {
			if (type == 'role')
				this.roleNotificationRecipients.splice(index, 1)
			else if (type == 'user')
				this.userNotificationRecipients.splice(index, 1)
			else if (type == 'external')
				this.externalNotificationRecipients.splice(index, 1)
		},
		addExternalNotificationRecipient() {

			// Push external recipient
			let newRecipient = {
				name: this.notificationRecipientModal.name
			}

			if (this.notificationRecipientModal.notifyByPhone)
				newRecipient.phone = this.notificationRecipientModal.phoneEmail
			else
				newRecipient.email = this.notificationRecipientModal.phoneEmail

			this.externalNotificationRecipients.push(newRecipient)
			
			// Clear fields
			this.notificationRecipientModal.name = ""
			this.notificationRecipientModal.notifyByPhone = false
			this.notificationRecipientModal.phoneEmail = ""

			// Emit and notify of change
			this.emitInput()
			this.alertSuccess(newRecipient.name + ' has been added.')
		},
		emitInput() {
			let vm = this

			this.$nextTick(() => {
				let emitPayload = {
					label: vm.label,
					type: vm.type,
					requiredField: vm.requiredField,
					default: vm.defaultValue,
					responseRequired: vm.responseRequired,
				}

				if (vm.notificationsActive) {
					emitPayload.notificationsActive = true
					emitPayload.notificationValue = vm.notificationValue
					emitPayload.userNotificationRecipients = this.userNotificationRecipients
					emitPayload.roleNotificationRecipients = this.roleNotificationRecipients
					emitPayload.externalNotificationRecipients = this.externalNotificationRecipients
				}

				if (vm.conditionalRemarksActive) {
					emitPayload.conditionalRemarksActive = true
					emitPayload.conditionalRemarksValue = (typeof(vm.conditionalRemarksValue) == 'object') ?
						vm.conditionalRemarksValue.filter(value => value !== null && typeof value !== 'undefined') : vm.conditionalRemarksValue
					emitPayload.conditionalRemarksLabel = vm.conditionalRemarksLabel
				}

				if (vm.conditionalImageActive) {
					emitPayload.conditionalImageActive = true
					if (typeof vm.conditionalImageValue == 'object' && vm.conditionalImageValue && 'length' in vm.conditionalImageValue && vm.conditionalImageValue.length)
						emitPayload.conditionalImageValue = vm.conditionalImageValue.filter(value => value !== null && typeof value !== 'undefined')
					else
						emitPayload.conditionalImageValue = vm.conditionalImageValue
					emitPayload.conditionalImageLabel = vm.conditionalImageLabel
				}

				if (vm.type == 'select') {
					emitPayload.options = vm.optionsArray
					emitPayload.defineOther = vm.defineOther
				}

				if (vm.type == 'select-multi') {
					emitPayload.options = vm.optionsArray
					emitPayload.defineOther = vm.defineOther
					emitPayload.default = []   // select-multi has no default
				}

				if (vm.type == 'boolean') {
					if (vm.buttonLanguage === "fr")
						emitPayload.buttonLanguage = "fr"
					emitPayload.positiveResponseRequired = vm.positiveResponseRequired
					emitPayload.negativeResponseRequired = vm.negativeResponseRequired
					emitPayload.positiveWarningMessage = vm.positiveWarningMessage
					emitPayload.negativeWarningMessage = vm.negativeWarningMessage
				}

				if (vm.type == 'image')
					emitPayload.imageIsStatic = vm.imageIsStatic

				if (vm.type == 'table') {
					emitPayload.columns = (vm.columnsArray.length) ? vm.columnsArray : null
					emitPayload.rows = (vm.rowsArray.length) ? vm.rowsArray : null
				}

				vm.$emit("input",emitPayload)
			})
		}
	},
	created() {
		this.setData()
	}
}
</script>

<style type="text/css" scoped>
	.btn-delete:hover {
		cursor: pointer
	}
	.form-builder-field {
		margin-bottom: 10px;
		padding: 10px;
		background-color: white;
		border: 1px dotted #808080;
	}

	.field-controls {
		display: flex;
		margin-bottom: 10px;
	}
</style>